import { render, staticRenderFns } from "./pass.vue?vue&type=template&id=b9204420&scoped=true"
import script from "./pass.vue?vue&type=script&lang=js"
export * from "./pass.vue?vue&type=script&lang=js"
import style0 from "./pass.vue?vue&type=style&index=0&id=b9204420&prod&lang=css"
import style1 from "./pass.vue?vue&type=style&index=1&id=b9204420&prod&scoped=true&lang=css"
import style2 from "./pass.vue?vue&type=style&index=2&id=b9204420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9204420",
  null
  
)

export default component.exports